// Servicio de beneficios
import { apiClient } from './api';
import { API_ENDPOINTS, API_BASE_URL } from '../config';

export const benefitsService = {
  /**
   * Obtener todos los beneficios activos
   * @returns {Promise<Object>} Lista de beneficios activos
   */
  async getAll() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.BENEFITS || `${API_BASE_URL}/api/benefits`);
      return response;
    } catch (error) {
      console.error('Error obteniendo beneficios:', error);
      throw error;
    }
  },

  /**
   * Estado de desbloqueo del usuario (Módulo 1, freemium).
   *
   * GET /api/benefits es público y por tanto no sabe quién pregunta, así que
   * el estado por usuario viaja aparte y el frontend cruza ambos.
   *
   * Devuelve null si el usuario no está autenticado: en ese caso la vista
   * simplemente trata todo como bloqueado.
   */
  async getUnlockState() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.BENEFITS_STATE);
      return response?.data ?? null;
    } catch (error) {
      return null;
    }
  },

  /**
   * Desbloquea un beneficio de muestra gratuita.
   *
   * El backend responde 402 con `code: 'PAYWALL'` cuando el usuario ya gastó su
   * beneficio de bienvenida — ese es el momento en que aparece el muro de pago.
   */
  async unlock(benefitId) {
    return apiClient.post(API_ENDPOINTS.BENEFIT_UNLOCK(benefitId), {});
  },
};

